import { FunctionComponent } from 'react';
import WidgetDisplay from './WidgetDisplay';

const WidgetContainer: FunctionComponent = () => {
  return <WidgetDisplay />;
};

export default WidgetContainer;
